module.exports = __webpack_public_path__ + "img/hhy_banner.69c5c05b.png";